/* eslint-disable import/prefer-default-export */
import { call, put, select, all, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import {
  getUser,
  getUserSuccess,
  getUsersSuccess,
  usersError,
  deleteUserSuccess,
  setUserClientSuccess,
  refreshUserInfo,
  changeUserRoleSuccess,
  syncInitStart,
  syncInitStop,
  syncMetaStart,
  syncMetaStop,
  changeUserPasswordSuccess,
  getUserLogsSuccess,
  getPaginatedUserLogsSuccess,
} from '../actions/users';

import {
  GET_USER,
  GET_USERS,
  GET_USER_LOGS,
  DELETE_USER,
  SET_USER_CLIENT,
  SET_USER_CLIENT_SUCCESS,
  SET_USER_ROLE_SUCCESS,
  DELETE_USER_CLIENT,
  DELETE_USER_CLIENT_SUCCESS,
  DELETE_USER_ROLE_SUCCESS,
  SELECT_USER,
  ADD_USER,
  CREATE_USER,
  CANCEL_CREATE_USER,
  CHANGE_USER_ROLE_SUCCESS,
  CHANGE_USER_ROLE,
  UPDATE_USER,
  SYNC_INIT,
  SYNC_META,
  CHANGE_USER_PASSWORD,
  GET_PAGINATED_USER_LOGS,
} from '../constants/action-types/users';

import { clientsError, addLoadingClient, removeLoadingClient } from '../actions/clients';

import { makeSelectIdTkn } from '../selectors/auth';
import clientApi from '../utils/clientApi';
import subscriptionApi from '../utils/subscriptionApi';

export function* getUsers() {
  const idToken = yield select(makeSelectIdTkn());
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    },
  };
  const resp = yield call(clientApi.get, '/users', options);
  yield put(getUsersSuccess(resp.data));
}

export function* getSelectedUser(action) {
  try {
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    const res = yield call(clientApi.get, `/users/${action.id}`, options);
    yield put(getUserSuccess(res.data));
  } catch (error) {
    yield put(clientsError());
    yield put(push('/administration/users'));
  }
}

export function* getSelectedUserLogs(action) {
  let logs = [];
  try {
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    logs = (yield call(clientApi.get, `/users/${action.id}/logs`, options)).data;
  } catch (error) {
    yield put(clientsError());
  }
  yield put(getUserLogsSuccess(logs));
}

export function* getPaginatedSelectedUserLogs({ data }) {
  let paginatedLogs = { logs: [], page: 0, amount: 0, pages: 0 };
  try {
    const url = `/users/${data.id}/logs/paginated?start=${data.start}&amount=${data.amount}&page=${data.page}`;
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    paginatedLogs = (yield call(clientApi.get, url, options)).data;
  } catch (error) {
    yield put(clientsError());
  }
  yield put(getPaginatedUserLogsSuccess(paginatedLogs));
}

export function* deleteUser(action) {
  try {
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    yield call(clientApi.delete, `/users/${action.id}`, options);
    yield put(deleteUserSuccess());
  } catch (error) {
    yield put(usersError());
  }
  yield put(push('/administration/users'));
}

export function* changeUserPassword({ changePasswordRequest, redirect }) {
  try {
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    yield call(clientApi.post, `/users/change-password`, changePasswordRequest, options);
    yield put(changeUserPasswordSuccess());
    if (redirect) yield put(push('/'));
  } catch (error) {
    yield put(usersError());
  }
}

export function* setUserClient(action) {
  try {
    // yield put(addLoadingClient(SET_USER_CLIENT));
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    yield call(clientApi.put, `/users/${action.uid}`, { clients: action.cid }, options);
    yield put(setUserClientSuccess(action.uid, action.cid));
    // Refresh the currently selected user
    // yield put(removeLoadingClient(SET_USER_CLIENT));
    yield put(getUser(action.uid));
  } catch (error) {
    yield put(usersError());
    yield put(push('/administration/users'));
  }
}

export function* setUserData(action) {
  try {
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    yield call(clientApi.put, `/users/${action.uid}`, action.data, options);
    // Refresh the currently selected user
    yield put(getUser(action.uid));
  } catch (error) {
    yield put(usersError());
    yield put(push('/administration/users'));
  }
}

export function* deleteUserClient() {
  // noop: use #setUserClient instead
  yield null;
}

export function* changeUserRole(action) {
  try {
    yield put(addLoadingClient(CHANGE_USER_ROLE));
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    const deletePath = `/users/${action.uid}/role/${action.data.rid}?cid=${action.data.cid}&appid=${action.data.appid}`;
    yield call(subscriptionApi.delete, deletePath, options);
    options.method = 'POST';
    const postPath = `/users/${action.uid}/role/${action.data.newRid}?cid=${action.data.cid}&appid=${action.data.appid}`;
    yield call(subscriptionApi.post, postPath, options);
    yield put(removeLoadingClient(CHANGE_USER_ROLE));
    yield put(changeUserRoleSuccess(action.uid));
  } catch (error) {
    yield put(usersError());
    yield put(push('/administration/users'));
  }
}

function* redirectToUserMain() {
  yield put(push(`/administration/users`));
}

function* redirectToCreateUser() {
  yield put(push(`/administration/users/create`));
}

function* watchRedirectAddUser() {
  yield takeEvery(ADD_USER, redirectToCreateUser);
}

function* createUser(action) {
  const idToken = yield select(makeSelectIdTkn());
  const body = action.data;
  clientApi.defaults.headers.common.Authorization = `Bearer ${idToken}`;
  const { error } = yield call(() => clientApi.post('/users', body).catch(e => ({ error: e })));
  yield put(refreshUserInfo(error ? { error: error.response.data } : {}));
  if (!error) {
    yield redirectToUserMain();
  }
}

function* watchRedirectCreateUser() {
  yield takeEvery(CREATE_USER, createUser);
}

function* watchRedirectCancelCreateUser() {
  yield takeEvery(CANCEL_CREATE_USER, redirectToUserMain);
}

function* redirectToSelectedUser(action) {
  yield put(push(`/administration/users/${action.id}`));
}

function* watchRedirectSelectedUser() {
  yield takeEvery(SELECT_USER, redirectToSelectedUser);
  yield takeEvery(DELETE_USER_CLIENT_SUCCESS, redirectToSelectedUser);
  yield takeEvery(SET_USER_CLIENT_SUCCESS, redirectToSelectedUser);
  yield takeEvery(SET_USER_ROLE_SUCCESS, redirectToSelectedUser);
  yield takeEvery(DELETE_USER_ROLE_SUCCESS, redirectToSelectedUser);
  yield takeEvery(CHANGE_USER_ROLE_SUCCESS, redirectToSelectedUser);
}

function* performSyncInit() {
  try {
    yield put(syncInitStart());
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    yield call(clientApi.post, `/sync/init`, {}, options);
    yield put(syncInitStop());
  } catch (error) {
    yield put(syncInitStop());
  }
}

function* performSyncMeta() {
  try {
    yield put(syncMetaStart());
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    yield call(clientApi.post, `/sync/meta`, {}, options);
    yield put(syncMetaStop());
  } catch (error) {
    yield put(syncMetaStop());
  }
}

// Watchers
function* watchGetPaginatedUserLogs() {
  yield takeEvery(GET_PAGINATED_USER_LOGS, getPaginatedSelectedUserLogs);
}

function* watchGetUserLogs() {
  yield takeEvery(GET_USER_LOGS, getSelectedUserLogs);
}

function* watchGetUser() {
  yield takeEvery(GET_USER, getSelectedUser);
}

function* watchGetUsers() {
  yield takeEvery(GET_USERS, getUsers);
}

function* watchUpdateUserClient() {
  yield takeEvery(SET_USER_CLIENT, setUserClient);
}

function* watchUpdateUser() {
  yield takeEvery(UPDATE_USER, setUserData);
}

function* watchDeleteUserClient() {
  yield takeEvery(DELETE_USER_CLIENT, deleteUserClient);
}

function* watchDeleteUser() {
  yield takeEvery(DELETE_USER, deleteUser);
}

function* watchChangeUserRole() {
  yield takeEvery(CHANGE_USER_ROLE, changeUserRole);
}

function* watchSyncInit() {
  yield takeEvery(SYNC_INIT, performSyncInit);
}

function* watchSyncMeta() {
  yield takeEvery(SYNC_META, performSyncMeta);
}

function* watchChangeUserPassword() {
  yield takeEvery(CHANGE_USER_PASSWORD, changeUserPassword);
}

export default function* usersSaga() {
  yield all([
    watchRedirectAddUser(),
    watchRedirectCreateUser(),
    watchRedirectCancelCreateUser(),
    watchDeleteUser(),
    watchDeleteUserClient(),
    watchRedirectSelectedUser(),
    watchDeleteUserClient(),
    watchUpdateUserClient(),
    watchUpdateUser(),
    watchGetUsers(),
    watchGetUser(),
    watchGetUserLogs(),
    watchGetPaginatedUserLogs(),
    watchChangeUserRole(),
    watchSyncInit(),
    watchSyncMeta(),
    watchChangeUserPassword(),
  ]);
}
